const dimensions = require('./mock/dimensions');
const refinements = require('./mock/refinements');
const items = require('./mock/items');
const tags = require('./mock/tags');

export default { dimensions, refinements, tags };
